import { useMutation, useQuery } from "@tanstack/react-query";
import { IPlan } from "~/types/billing";
import { PLANS } from "./types";
import { shopifySubscription, getPlans, stripeSubscription, updateCard, cancelSubscription } from "./requests";

export const usePlans = () =>
  useQuery<Array<IPlan>>(PLANS, () => getPlans, { refetchInterval: 1000, cacheTime: 0 });

export const useShopifySubscription = () => useMutation(shopifySubscription);

export const useStripeSubscription = () => useMutation(stripeSubscription);

export const useUpdateCard = () => useMutation(updateCard);

export const useCancelSubscription = () => useMutation(cancelSubscription);
